import graphQLClient from 'config/graphql-instance';
import { gql } from 'graphql-request';

type getaAIUsageParams = {
  email: string,
  model: string
}

export type windowsAIUsage = {
    period: string;
    prompt_tokens: number;
    completion_tokens: string;
    total_tokens: string;
    requests: number;
    prompt_tokens_percent: number;
    completion_tokens_percent: number;
    total_tokens_percent: number;
    requests_percent: number;
  }

export type getAIReturn = {
  getAiUsage:{
    allowed: boolean;
    message: string;
    windows: windowsAIUsage[]
  }
}

const getAIUsageQuery = gql`
    query getAIUsage($email: String!, $model: String!) {
      getAiUsage(email: $email, model: $model) {
      allowed
      message
      windows {
        period
        prompt_tokens
        completion_tokens
        total_tokens
        requests
        prompt_tokens_percent
        completion_tokens_percent
        total_tokens_percent
        requests_percent
      }
    }
  }

`;

export const getAIUsage = async (params:getaAIUsageParams) => {
  const response = await graphQLClient().request<getAIReturn, getaAIUsageParams>(getAIUsageQuery, params);
  return response;
};

export type AiCost = {
  readonly amount: number;
  readonly per: number;
};

export type AiCosts = {
  readonly prompt_tokens: AiCost;
  readonly completion_tokens: AiCost;
};

export type AiWindow = {
  readonly period: string;
  readonly prompt_tokens: number;
  readonly completion_tokens: number;
  readonly total_tokens: number;
  readonly requests: number;
  readonly prompt_tokens_percent?: number;
  readonly completion_tokens_percent?: number;
  readonly total_tokens_percent?: number;
  readonly requests_percent?: number;
};

export type AiModel = {
  readonly model: string;
  readonly costs: AiCosts;
  readonly limits: Record<string, Record<string, number>>;
  readonly windows: readonly AiWindow[];
};

export type GetAiActivityResponse = {
  readonly getAiActivity: {
    readonly models: readonly AiModel[];
  };
};

const getAiActivityQuery = gql`
  query GetAiActivity($email: String!) {
    getAiActivity(email: $email) {
      models {
        model
        costs {
          prompt_tokens { amount per }
          completion_tokens { amount per }
        }
        limits
        windows {
          period
          prompt_tokens
          completion_tokens
          total_tokens
          requests
          prompt_tokens_percent
          completion_tokens_percent
          total_tokens_percent
          requests_percent
        }
      }
    }
  }
`;

export const getAiActivity = async (email: string) => {
  const response = await graphQLClient().request<GetAiActivityResponse, { email: string }>(getAiActivityQuery, { email });
  return response;
};
